import { configureStore } from '@reduxjs/toolkit'
import authenticationReducer from "./features/auth/authenticationSlice"
import permissionsReducer from "./data/permissions/permissionsSlice"

export default configureStore({
    reducer: {
        authentication: authenticationReducer,
        permissions: permissionsReducer
    }
});
